module.exports = __webpack_public_path__ + "img/5.c40cc952.jpg";